import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoResponsavel } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoResponsavelService extends BaseResourceService<FavorecidoResponsavel> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-responsaveis`, injector);
  }

}
